declare var swal: any;
import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../../services/spinner.service';
import { ActorService } from '../../../../services/actor.service';
import { ActorProfileRequest, ActorProfileController, ActorImageController, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, GuardianInfoController, GuardianInfoRequest, SaveCustomerMessageRequest, CustomerMessageRequest, CustomerMessageController, OTFormDetailByReportCodeController, OTFormDetailByReportCodeRequest, SectionData, TreatmentCyclesByActorCodeController, TreatmentCyclesByActorCodeRequest, FollicularPickUpsBetweenDateController, FollicularPickUpsBetweenDateRequest, FollicularPickUpsDetailController, FollicularPickUpsDetailRequest, SaveFollicularPickupsDetailRequest, FollicularPickUpsByCodeController, FollicularPickUpsByCodeRequest, SaveFollicularPickupsDetailV2Request, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, UpdateIvfCycleByActivityRequest, ReadyForPickUpsBetweenDateController, ReadyForPickUpsBetweenDateRequest, DSAActivityByCycleCodeController, DSAActivityByCycleCodeRequest } from '../../../../models/actor/actor';
import { AppData } from '../../../../models/appdata';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbDateStruct, NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
//import { NgbdUploadActorImageModal } from '../../../../../modals/uploadactorimage/ngbuploadactorimage.modal';
import { ActorPersonalInfoController, ActorPersonalDetailInfoRequest, ActorPersonalDetailInfoController } from '../../../../models/profileinfo/profileinfo.model';
import { AppFeaturesList } from '../../../../constants/constants';
//import  './profilesteps.js';
import { HCPService } from '../../../../services/hcp.service';
declare var mess1: any;
declare var stepObject: any;
declare var pSteps: any;
declare var webGlObject: any;

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { routerTransition } from '../../../../animations/router.animations';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
//import { NgbTcDetailsModal } from '../tcdetails.modal';
//import { NgbEventAddModal } from './eventadd.modal';
import { FdActorReportsDocController, FDActorDocRequest } from '../../../../../../../src/app/ncs/models/formdesign/fd.model';
import { FDService } from '../../../../../../../src/app/ncs/services/fd.service';
import { PickPipe, PickPipe2 } from '../../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
import { NgbSearchProviderModal } from './searchprovider.modal';
import { NgbAddPickUpTestModal } from './addpickuptest.modal';
import { NgbAddPickUpMedicineModal } from './addpickupmedicine.modal';
import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'ivfpickupreadyedit',
  templateUrl: './ivfpickupreadyedit.component.html',
  styleUrls: ['./ivfpickupreadyedit.component.scss'],
  animations: [routerTransition()]
})

export class IvfPickupReadyEditComponent implements OnInit, AfterViewInit {

  //Variable Declaration
  currentPage: string = "About"
  public isRequesting: boolean = false;
  CurrentActorProfileRequest: ActorProfileRequest;
  CurrentActorProfileController: ActorProfileController;
  CurrentUpdateIvfCycleByActivityRequest: UpdateIvfCycleByActivityRequest;
  //CurrentFdActorReportsDocController: FdActorReportsDocController[];
  //CurrentFDActorDocRequest: FDActorDocRequest;
  public ApiResData: ApiResponseModel;

  ValueChangeActorPersonalInfoController: ActorPersonalInfoController;
  ValueChangeActorImageController: ActorImageController;
  CurrentSaveFollicularPickupsDetailV2Request: SaveFollicularPickupsDetailV2Request;
  @Input() NurseActorCode: number = 0;
  @Input() ActorCode: number;
  @Input() CycleCode: number;
  @Input() Duration: number;
  @Input() FormattedCode: number;
  @Input() DisplayName: string;
  searchTitle: string;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  OvulationTriggerDate: NgbDateStruct;
  ExpiryDate: NgbDateStruct;
  ExpiryDate2: NgbDateStruct;

  OvumPickupdate: NgbDateStruct;
  SelectedFromDate: NgbDateStruct;
  ActualPickupDate: NgbDateStruct;
  //
  //public FormattedCode: number = 0;
  public IsSetAccessRights: boolean;
  public CanEditProfileInfo: number = 0;
  public CanEditContactInfo: number = 0;
  public CanShowProfileInfo: number = 0;
  public CanShowContactInfo: number = 0;
  public Code: string;
  public PatientActorCode: number;
  public PatientCycleCode: number;
  public LMPDate: Date;
  public ActivityDate: NgbDateStruct;
  //public Code: number;

  public CanShowProfileSummary: number = 0;
  public CanEditProfileSummary: number = 0;

  public CanShowJobPreferences: number = 0;
  public CanEditJobPreferences: number = 0;

  public CanShowEducation: number = 0;
  public CanEditEducation: number = 0;

  public CanShowEmploymentHistory: number = 0;
  public CanEditEmploymentHistory: number = 0;

  public CanShowReferences: number = 0;
  public CanEditReferences: number = 0;

  public CanShowIdentities: number = 0;
  public CanEditIdentities: number = 0;

  public CanShowCertifications: number = 0;
  public CanEditCertifications: number = 0;

  public CanShowMedicalFitness: number = 0;
  public CanEditMedicalFitness: number = 0;

  public CanShowProfileImage: number = 0;
  public CanEditProfileImage: number = 0;

  public CanShowLegalinfo: number = 0;
  public CanEditLegalinfo: number = 0;
  public showprofile: boolean = true;
  public showmessages: boolean = false;
  public ScanDetails: boolean = false;
  public Showpickup: boolean = true;
  public Showivf: boolean = false;
  public displayPatientdata: boolean = true;
  public displayscansdata: boolean = false;
  //
  public SelectedReport: string;
  public SelectedActorCode: number = 92;
  TodayDate = new Date();


  //CurrentFollicularPickUpsBetweenDateController: FollicularPickUpsBetweenDateController[];
  //CurrentFollicularPickUpsBetweenDateRequest: FollicularPickUpsBetweenDateRequest;
  //LoadPatients() {
  //  this.CurrentFollicularPickUpsBetweenDateRequest = new FollicularPickUpsBetweenDateRequest();

  //  this.CurrentFollicularPickUpsBetweenDateRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  //  this.pdata = this.CurrentFollicularPickUpsBetweenDateController;

  //  this.GetFollicularPickUpsBetweenDateController();
  //}

  //GetFollicularPickUpsBetweenDateController() {
  //  this.StartRefreshing();

  //  this.CurrentFollicularPickUpsBetweenDateRequest.FromDate = new Date();
  //  this.CurrentFollicularPickUpsBetweenDateRequest.ToDate = new Date();
  //  this.CurrentFollicularPickUpsBetweenDateRequest.Facility = "1";

  //  this.actorservice.GetFollicularPickUpsBetweenDateController(this.CurrentFollicularPickUpsBetweenDateRequest)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {

  //        this.CurrentFollicularPickUpsBetweenDateController = this.ApiResData.Result;
  //        this.pdata = this.CurrentFollicularPickUpsBetweenDateController;


  //        this.stopRefreshing();


  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //        }
  //        else {
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //        }
  //      }

  //    },


  //      (error) => {

  //        if (error == "401 - Unauthorized") {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();



  //        }
  //        else {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();
  //        }
  //      }


  //    );
  //}
  CurrentReadyForPickUpsBetweenDateController: ReadyForPickUpsBetweenDateController[];
  CurrentReadyForPickUpsBetweenDateRequest: ReadyForPickUpsBetweenDateRequest;
  LoadPatients() {
    this.CurrentReadyForPickUpsBetweenDateRequest = new ReadyForPickUpsBetweenDateRequest();

    this.CurrentReadyForPickUpsBetweenDateRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.pdata = this.CurrentReadyForPickUpsBetweenDateController;

    this.GetReadyForPickUpsBetweenDateController();
  }

  GetReadyForPickUpsBetweenDateController() {
    this.StartRefreshing();

    this.CurrentReadyForPickUpsBetweenDateRequest.FromDate = new Date();
    this.CurrentReadyForPickUpsBetweenDateRequest.ToDate = new Date();
    this.CurrentReadyForPickUpsBetweenDateRequest.FacilityCode = AppData.Instance().SelectedBranchCode;

    this.actorservice.GetReadyForPickUpsBetweenDateController(this.CurrentReadyForPickUpsBetweenDateRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentReadyForPickUpsBetweenDateController = this.ApiResData.Result;
          this.pdata = this.CurrentReadyForPickUpsBetweenDateController;


          this.stopRefreshing();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  constructor(private router: Router,
    public printService: PrintService, private spinner: NgxSpinnerService,
    private route: ActivatedRoute, private loaderService: SpinnerService, private filter: PickPipe2, private parserFormatter: NgbDateParserFormatter, private actorservice: ActorService, private hcpservice: HCPService, private fdservice: FDService, private tosterservice: NGXToastrService,
    private modalService: NgbModal) {

    //stepObject.init();
    //webGlObject.init();
  }


  ngOnInit() {
    //this.Code = this.route.snapshot.paramMap.get('Code');
    //alert(this.Code);
    $.getScript('./healins-assets/js/jquery.steps.js');
    $.getScript('./healins-assets/js/profilesteps.js');
    this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
    //this.CurrentFDActorDocRequest = new FDActorDocRequest();
    ///////////////////////
    this.LoadPatients();
    this.CurrentUpdateIvfCycleByActivityRequest = new UpdateIvfCycleByActivityRequest();
    this.CurrentUpdateIvfCycleByActivityRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.LoadPatients();
    ///this.LoadClinics();
    //this.LoadMessages();
    this.PatientActorCode = this.ActorCode;
    this.PatientCycleCode = this.CycleCode;



    this.CurrentSaveFollicularPickupsDetailV2Request = new SaveFollicularPickupsDetailV2Request();

    this.CurrentSaveFollicularPickupsDetailV2Request.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentActorProfileRequest = new ActorProfileRequest();
    this.CurrentActorProfileController = new ActorProfileController();
    if (this.NurseActorCode > 0) {
      this.CurrentActorProfileRequest.ActorCode = this.NurseActorCode;
    }
    else {
      this.CurrentActorProfileRequest.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    }
    this.CurrentActorProfileRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.ValueChangeActorPersonalInfoController = new ActorPersonalInfoController();
    this.ValueChangeActorImageController = new ActorImageController();
    // Horizontal Timeline js for user timeline
    //$.getScript('./assets/js/vertical-timeline.js');
    //



  }
  FormData: SectionData[];
  CurrentOTFormDetailByReportCodeController: OTFormDetailByReportCodeController[];
  CurrentOTFormDetailByReportCodeRequest: OTFormDetailByReportCodeRequest;
  LoadClinics(reportCode: string) {

    var r1: OTFormDetailByReportCodeRequest = new OTFormDetailByReportCodeRequest();
    r1.ConditionalOperator = 10;

    r1.PatientReportCode = this.Code;
    r1.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.GetOTFormDetailByReportCodeController(r1).subscribe
      ((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.stopRefreshing();
          //  this.CurrentOTFormDetailByReportCodeController = this.ApiResData.Result;
          //alert(this.CurrentOTFormDetailByReportCodeController);
          // var reportCode: number = this.CurrentOTFormsByFormattedCodeController[0].PatientReportCode;
          this.FormData = this.ApiResData.Result;
          //if (this.FormData.length > 0)
          //  alert(this.FormData[0].Title);
          //else {
          //  alert("no data retrieved");
          //}



        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }

  onAssignedToActorCode(event: any) {

    if (event != null) {
      //alert(this.SelectedReport);
      //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
      //this.CurrentFdActorReportsDocController[0].TemplateName = event;
      // console.log('event--_>' + event);
      //   }
      this.Code = this.SelectedReport;
      this.LoadClinics(this.Code);
    }

  }


  ngAfterViewInit() {
    // pSteps.loadStep();
  }




  //

  //
  dataChanged(newobj) {

    this._GetReadyForPickUpsBetweenDateController();
  }
  _GetReadyForPickUpsBetweenDateController() {
    this.StartRefreshing();

    this.CurrentReadyForPickUpsBetweenDateRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentReadyForPickUpsBetweenDateRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentReadyForPickUpsBetweenDateRequest.FacilityCode = AppData.Instance().SelectedBranchCode;

    this.actorservice.GetReadyForPickUpsBetweenDateController(this.CurrentReadyForPickUpsBetweenDateRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentReadyForPickUpsBetweenDateController = this.ApiResData.Result;
          this.pdata = this.CurrentReadyForPickUpsBetweenDateController;


          this.stopRefreshing();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  DecrementDate() {
    //this.dateI = new Date();
    //var i = this.dateI.valueOf() + 86400000;
    //this.dateI = new Date(i);
    //this.SelectedFromDate = dateI;
    //var ind: number = 0;
    //this.diff = this.diff - 1;
    //alert(this.diff);
    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    //this.parserFormatter.parse(this.SelectedFromDate).;

    d = new Date((new Date(d)).getTime() - (60 * 60 * 24 * 1000));
    //    d.getFullYear
    //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

    //  this.SelectedFromDate = this.SelectedFromDate.
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this._GetReadyForPickUpsBetweenDateController();
    //ind++;
  }
  IncrementDate() {
    //this.dateI = new Date();
    //var i = this.dateI.valueOf() + 86400000;
    //this.dateI = new Date(i);
    //this.SelectedFromDate = dateI;
    //var ind: number = 0;
    //this.diff = this.diff - 1;
    //alert(this.diff);
    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    //this.parserFormatter.parse(this.SelectedFromDate).;

    d = new Date((new Date(d)).getTime() + (60 * 60 * 24 * 1000));
    //    d.getFullYear
    //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

    //  this.SelectedFromDate = this.SelectedFromDate.
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this._GetReadyForPickUpsBetweenDateController();
    //ind++;
  }
  showPage(page: string) {
    this.currentPage = page;
  }
  BackToProfile() {
    alert("method");
    this.router.navigate(['testnurse/dashboard']);

  }
  BackToTreatment() {
    alert("Thistrearment");
    this.router.navigate(['testnurse/ivfdashboard']);
  }






  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

  SelectedpatientDetails: ReadyForPickUpsBetweenDateController;

  Selectedpatient(objCategory: any) {
    var Patient: ReadyForPickUpsBetweenDateController = objCategory;
    if (Patient != null) {
      this.SelectedpatientDetails = null;
      this.SelectedpatientDetails = Patient;
      this.ScanDetails = true;
      this.LoadOvariesData();
      this.LoadActorCode();
      //this.LoadScansData();
      //this.LoadOvaryData();
      //this.LoadTestData();
      //this.LoadMedicineData();
      this.LoadLmp()
    }

  }
  Selectedpatient2(objCategory: any) {
    var Patient: ReadyForPickUpsBetweenDateController = objCategory;
    if (Patient != null) {
      this.SelectedpatientDetails = null;
      this.SelectedpatientDetails = Patient;
      //this.ScanDetails = true;
      this.displayPatientdata = false;
      this.displayscansdata = true;
      //this.LoadScansData();
      //this.LoadOvaryData();
      this.LoadOvariesData();
      this.LoadTestData();
      this.LoadMedicineData();
      this.LoadLmp()
    }

  }
  LoadLmp() {
    this.LMPDate = this.SelectedpatientDetails.LMP;
  }
  CurrentFollicularPickUpsByCodeController: FollicularPickUpsByCodeController[];
  FollicularPickupEndInfo: FollicularPickUpsByCodeController;
  CurrentFollicularPickUpsByCodeRequest: FollicularPickUpsByCodeRequest;

  LoadOvariesData() {
    //alert("ScansData")
    this.CurrentFollicularPickUpsByCodeRequest = new FollicularPickUpsByCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentFollicularPickUpsByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetFollicularPickUpsByCodeController();
  }

  GetFollicularPickUpsByCodeController() {
    // this.StartRefreshing();
    this.spinner.show();
    this.CurrentFollicularPickUpsByCodeRequest.IvfCycleFolliculePickupCode = this.SelectedpatientDetails.PickUpCode;
    //this.CurrentFollicularPickUpsDetailRequest.CycleActivity = this.SelectedpatientDetails.PickUpCycleActivity;
    //this.CurrentFollicularPickUpsDetailRequest.TreatmentCycle = this.SelectedpatientDetails.PickUpTreatmentCycle;
    //this.CurrentFollicularPickUpsDetailRequest.FollicularPickup = this.SelectedpatientDetails.PickUpCode;
    //this.CurrentFollicularPickUpsDetailRequest.OvumPlannedPickupDate = this.SelectedpatientDetails.OvumPlannedPickupDate;
    //this.CurrentFollicularPickUpsDetailRequest.ActorCode = this.SelectedpatientDetails.ActorCode;
    //alert(this.FormattedCode);
    this.actorservice.GetFollicularPickUpsByCodeController(this.CurrentFollicularPickUpsByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentFollicularPickUpsByCodeController = this.ApiResData.Result;
          this.FollicularPickupEndInfo = this.CurrentFollicularPickUpsByCodeController[0];
          if (this.FollicularPickupEndInfo.OvulationTriggerDate != null) {
            var SValidFrom = new Date(this.FollicularPickupEndInfo.OvulationTriggerDate);
            if (SValidFrom.getFullYear() > 1900) {
              console.log('this.UpdateDate >1990');
              this.OvulationTriggerDate = {

                year: SValidFrom.getFullYear(),
                month: SValidFrom.getMonth() + 1,
                day: SValidFrom.getDate()
              }
            }
          }
          if (this.FollicularPickupEndInfo.OvulationTriggerDate2 != null) {
            var SValidFrom = new Date(this.FollicularPickupEndInfo.OvulationTriggerDate2);
            if (SValidFrom.getFullYear() > 1900) {
              console.log('this.UpdateDate >1990');
              this.ActivityDate = {

                year: SValidFrom.getFullYear(),
                month: SValidFrom.getMonth() + 1,
                day: SValidFrom.getDate()
              }
            }
          }
          if (this.FollicularPickupEndInfo.ExpiryDate != null) {
            var SValidFrom = new Date(this.FollicularPickupEndInfo.ExpiryDate);
            if (SValidFrom.getFullYear() > 1900) {
              console.log('this.UpdateDate >1990');
              this.ExpiryDate = {

                year: SValidFrom.getFullYear(),
                month: SValidFrom.getMonth() + 1,
                day: SValidFrom.getDate()
              }
            }
          }
          if (this.FollicularPickupEndInfo.ExpiryDate2 != null) {
            var SValidFrom = new Date(this.FollicularPickupEndInfo.ExpiryDate2);
            if (SValidFrom.getFullYear() > 1900) {
              console.log('this.UpdateDate >1990');
              this.ExpiryDate2 = {

                year: SValidFrom.getFullYear(),
                month: SValidFrom.getMonth() + 1,
                day: SValidFrom.getDate()
              }
            }
          }
          if (this.FollicularPickupEndInfo.OvumPickupdate != null) {
            var SValidFrom = new Date(this.FollicularPickupEndInfo.OvumPickupdate);
            if (SValidFrom.getFullYear() > 1900) {
              console.log('this.UpdateDate >1990');
              this.OvumPickupdate = {

                year: SValidFrom.getFullYear(),
                month: SValidFrom.getMonth() + 1,
                day: SValidFrom.getDate()
              }
            }
          }

          //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
          //  = this.FollicularScanEndInfo.EndometriumThickness;
          //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
          //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          // this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentTreatmentCyclesByActorCodeController: TreatmentCyclesByActorCodeController[];
  ActorCodeDetails: TreatmentCyclesByActorCodeController;
  SelectedTreatmentCycle: TreatmentCyclesByActorCodeController;

  CurrentTreatmentCyclesByActorCodeRequest: TreatmentCyclesByActorCodeRequest;
  LoadActorCode() {
    this.CurrentTreatmentCyclesByActorCodeRequest = new TreatmentCyclesByActorCodeRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentTreatmentCyclesByActorCodeRequest.Branch = 0;
    this.CurrentTreatmentCyclesByActorCodeRequest.ActorCode = 0;
    this.CurrentTreatmentCyclesByActorCodeRequest.ConditionalOperator = 10;
    this.CurrentTreatmentCyclesByActorCodeRequest.FromDate = new Date();
    this.CurrentTreatmentCyclesByActorCodeRequest.ToDate = new Date();
    this.CurrentTreatmentCyclesByActorCodeRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentTreatmentCyclesByActorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetTreatmentCyclesByActorCodeController();
  }

  GetTreatmentCyclesByActorCodeController() {
    // this.StartRefreshing();


    this.actorservice.GetTreatmentCyclesByActorCodeController(this.CurrentTreatmentCyclesByActorCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentTreatmentCyclesByActorCodeController = this.ApiResData.Result;
          this.ActorCodeDetails = this.CurrentTreatmentCyclesByActorCodeController[0];

          //this.SelectedActorCode = this.CurrentTreatmentCyclesByActorCodeController[0].EggActorCode;
          //this.SelectedTreatmentCycle = this.CurrentTreatmentCyclesByActorCodeController[0];
          //this.LMPDate = this.SelectedTreatmentCycle.LMP;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          //this.stopRefreshing();
          //this.LoadPlan();
          this.LoadDSAData();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  GetActorCode(EggSourceType: string): number {
    // alert("new");
    if (EggSourceType == 'Donor') {
      var DonorActorCode = this.ActorCodeDetails.EggActorCode;
      return DonorActorCode;
    }
    else if (EggSourceType == 'Self') {
      var OwnerActorCode = this.ActorCodeDetails.OwnerActorCode;
      return OwnerActorCode;
    }
  }
  CurrentDSAActivityByCycleCodeController: DSAActivityByCycleCodeController[];
  DSADetails: DSAActivityByCycleCodeController;
  CurrentDSAActivityByCycleCodeRequest: DSAActivityByCycleCodeRequest;

  LoadDSAData() {
    //alert("ScansData")
    this.CurrentDSAActivityByCycleCodeRequest = new DSAActivityByCycleCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentDSAActivityByCycleCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetDSAActivityByCycleCodeController();
  }

  GetDSAActivityByCycleCodeController() {
    //this.StartRefreshing();

    //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.CurrentDSAActivityByCycleCodeRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentDSAActivityByCycleCodeRequest.ConditionalOperator = 10;
    this.CurrentDSAActivityByCycleCodeRequest.ActorCode = this.GetActorCode(this.SelectedpatientDetails.EggSourceType);
    //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
    // this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
    //alert(this.FormattedCode);
    this.actorservice.GetDSAActivityByCycleCodeController(this.CurrentDSAActivityByCycleCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentDSAActivityByCycleCodeController = this.ApiResData.Result;
          this.DSADetails = this.GetCycleActivity(this.GetActorCode(this.SelectedpatientDetails.EggSourceType), this.SelectedpatientDetails.ProtocolStartDate)[0];
          //alert(this.DSADetails);
          //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
          //this.Antag = this.GetCycleActivity(ActorCode, Date)[0].ANTAG;
          //this.Stimulation = this.GetCycleActivity(ActorCode, Date)[0].STIMULATION;

          //  this.GetDsADetails(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate);
          //var list = this.CurrentDSAActivityByCycleCodeController.filter(


          //    function (a) {
          //        var Date = this.FollicularScanEndInfo.ScanDate;
          //        var ActorCode = this.SelectedpatientDetails.ActorID;
          //        return a.ActivityDate == Date && a.ActorCode == ActorCode
          //    });

          //this.CurrentDSAActivityByCycleCodeController = list;
          //alert(this.CurrentDSAActivityByCycleCodeController[0].DOC);
          //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
          //this.Antag = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].ANTAG;
          //this.Stimulation = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].STIMULATION;
          //alert(this.Doc1);
          //alert(this.Antag);
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          //this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();
          this.spinner.hide();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  GetCycleActivity(ReceipientActorCode: number, TransferDateNew: Date): DSAActivityByCycleCodeController[] {
    //alert(ReceipientActorCode);
    //alert(TransferDateNew);
    return this.CurrentDSAActivityByCycleCodeController.filter(
      function (v, i, d) {

        return v.ActorCode == ReceipientActorCode && v.ActivityDate == TransferDateNew;
      }
    )

  }
  SaveOvulationtrigger(CurrentFollicularPickupDetails: FollicularPickUpsByCodeController) {
    //this.CurrentSaveFollicularPickupsDetailV2Request.ActivityTime = CurrentFollicularPickupDetails.TriggerTime;

    //this.CurrentSaveFollicularPickupsDetailV2Request.Dosage = CurrentFollicularPickupDetails.Dose;
    //this.CurrentSaveFollicularPickupsDetailV2Request.ActivityDate = CurrentFollicularPickupDetails.OvumPlannedPickupDate;

    //this.CurrentSaveFollicularPickupsDetailV2Request.ActualDate = CurrentFollicularPickupDetails.ActualPickupDate;
    //this.CurrentSaveFollicularPickupsDetailV2Request.ActualTime = CurrentFollicularPickupDetails.ActualPickupTime;
    //this.CurrentSaveFollicularPickupsDetailV2Request.Surgeon = CurrentFollicularPickupDetails.Surgeon;
    this.CurrentSaveFollicularPickupsDetailV2Request.AsstSurgeon = CurrentFollicularPickupDetails.AsstSurgeon;
    this.CurrentSaveFollicularPickupsDetailV2Request.Anesthesiologist = CurrentFollicularPickupDetails.Anesthesiologist;
    this.CurrentSaveFollicularPickupsDetailV2Request.SurgeonName = CurrentFollicularPickupDetails.SurgeonName;
    this.CurrentSaveFollicularPickupsDetailV2Request.AsstSurgeonName = CurrentFollicularPickupDetails.AsstSurgeonName;
    this.CurrentSaveFollicularPickupsDetailV2Request.AnesthesiologistName = CurrentFollicularPickupDetails.AnesthesiologistName;
    //this.CurrentSaveFollicularPickupsDetailV2Request.AnaesthesiaType = CurrentFollicularPickupDetails.AnaesthesiaType;
    this.CurrentSaveFollicularPickupsDetailV2Request.NeedleUsed = CurrentFollicularPickupDetails.NeedleUsed;
    this.CurrentSaveFollicularPickupsDetailV2Request.Route = CurrentFollicularPickupDetails.Route;
    this.CurrentSaveFollicularPickupsDetailV2Request.Complications = CurrentFollicularPickupDetails.Complications;
    this.CurrentSaveFollicularPickupsDetailV2Request.LFollicleCount = CurrentFollicularPickupDetails.LFollicleCount;
    this.CurrentSaveFollicularPickupsDetailV2Request.LFollicleAspirated = CurrentFollicularPickupDetails.LFollicleAspirated;
    this.CurrentSaveFollicularPickupsDetailV2Request.RFollicleCount = CurrentFollicularPickupDetails.RFollicleCount;
    this.CurrentSaveFollicularPickupsDetailV2Request.RFollicleAspirated = CurrentFollicularPickupDetails.RFollicleAspirated;
    this.CurrentSaveFollicularPickupsDetailV2Request.TotalLtOocytes = CurrentFollicularPickupDetails.TotalLtOocytes;
    this.CurrentSaveFollicularPickupsDetailV2Request.TotalRtOocytes = CurrentFollicularPickupDetails.TotalRtOocytes;
    this.CurrentSaveFollicularPickupsDetailV2Request.TotalOocytes = CurrentFollicularPickupDetails.TotalOocytes;
    this.CurrentSaveFollicularPickupsDetailV2Request.MinPickupSize = CurrentFollicularPickupDetails.MinPickupSize
    //this.CurrentSaveFollicularPickupsDetailV2Request.Dosage = CurrentFollicularPickupDetails.Dose;

  }
  onSubmit() {
    this.spinner.show();
    this.CurrentSaveFollicularPickupsDetailV2Request.ActivityDate = new Date(this.parserFormatter.format(this.OvulationTriggerDate));
    this.CurrentSaveFollicularPickupsDetailV2Request.ActivityDate2 = new Date(this.parserFormatter.format(this.ActivityDate));
    //this.CurrentSaveFollicularPickupsDetailV2Request.Dosage = this.FollicularPickupEndInfo.Dose;
    this.CurrentSaveFollicularPickupsDetailV2Request.ActivityTime = this.FollicularPickupEndInfo.OvulationTriggerTime;
    this.CurrentSaveFollicularPickupsDetailV2Request.ActivityTime2 = this.FollicularPickupEndInfo.OvulationTriggerTime2;
    this.CurrentSaveFollicularPickupsDetailV2Request.FollicularPickupCode = this.FollicularPickupEndInfo.IvfCycleFolliculePickupCode;
    this.CurrentSaveFollicularPickupsDetailV2Request.TreatmentCycleCode = this.FollicularPickupEndInfo.TreatmentCycle;
    this.CurrentSaveFollicularPickupsDetailV2Request.Dosage = this.FollicularPickupEndInfo.Dosage;
    this.CurrentSaveFollicularPickupsDetailV2Request.Dosage2 = this.FollicularPickupEndInfo.Dosage2;
    this.CurrentSaveFollicularPickupsDetailV2Request.Batch = this.FollicularPickupEndInfo.BatchNo;
    this.CurrentSaveFollicularPickupsDetailV2Request.Batch2 = this.FollicularPickupEndInfo.BatchNo2;
    this.CurrentSaveFollicularPickupsDetailV2Request.ExpiryDate = new Date(this.parserFormatter.format(this.ExpiryDate));
    this.CurrentSaveFollicularPickupsDetailV2Request.ExpiryDate2 = new Date(this.parserFormatter.format(this.ExpiryDate2));
    this.CurrentSaveFollicularPickupsDetailV2Request.TriggerType = this.FollicularPickupEndInfo.triggertype;
    if (this.CurrentSaveFollicularPickupsDetailV2Request.TriggerType == 'Dual Trigger' || this.CurrentSaveFollicularPickupsDetailV2Request.TriggerType == 'Double Trigger') {
      this.CurrentSaveFollicularPickupsDetailV2Request.ConditionalOperator = 10;
    }
    else if (this.CurrentSaveFollicularPickupsDetailV2Request.TriggerType == 'Single Dose') {
      this.CurrentSaveFollicularPickupsDetailV2Request.ConditionalOperator = 2;
    }
    //this.CurrentSaveFollicularPickupsDetailV2Request.
    this.CurrentSaveFollicularPickupsDetailV2Request.ActivityApprovedActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.CurrentSaveFollicularPickupsDetailV2Request.ActivityApprovedEmpCode = AppData.Instance().UserLoginDetails.EmployeeCode;
    this.CurrentSaveFollicularPickupsDetailV2Request.ActivityApprovedEmpCode2 = AppData.Instance().UserLoginDetails.EmployeeCode;

    //this.CurrentSaveFollicularPickupsDetailV2Request.TreatmentCycle = this.FollicularPickupEndInfo.PickUpTreatmentCycle;
    //this.CurrentSaveFollicularPickupsDetailV2Request.FollicularGrowth = this.FollicularPickupEndInfo.FollicularGrowth;
    //this.CurrentSaveFollicularPickupsDetailV2Request.CycleActivity = this.FollicularPickupEndInfo.PickupCycleActivity;
    //this.CurrentSaveFollicularPickupsDetailV2Request.ConditionalOperator = 2;
    this.actorservice.SaveFollicularPickupsDetailV2(this.CurrentSaveFollicularPickupsDetailV2Request)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.spinner.hide();
            //this.activeModal.close();
            //this.clearData();
            //this.LoadScansData();
            this.stopRefreshing();

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.spinner.hide();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            alert(this.ApiResData.ErrorData);


          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.spinner.hide();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
            this.spinner.hide();


          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
            this.spinner.hide();
          }
        }
      );


  }
  onSubmitSchedule() {
    this.CurrentSaveFollicularPickupsDetailV2Request.ActualDate = new Date(this.parserFormatter.format(this.OvumPickupdate));
    this.CurrentSaveFollicularPickupsDetailV2Request.ActualTime = this.FollicularPickupEndInfo.OvumPickupTime;
    this.CurrentSaveFollicularPickupsDetailV2Request.FollicularPickupCode = this.FollicularPickupEndInfo.IvfCycleFolliculePickupCode;
    this.CurrentSaveFollicularPickupsDetailV2Request.TreatmentCycleCode = this.FollicularPickupEndInfo.TreatmentCycle;
    this.CurrentSaveFollicularPickupsDetailV2Request.ActivityApprovedActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.CurrentSaveFollicularPickupsDetailV2Request.ActivityApprovedEmpCode = AppData.Instance().UserLoginDetails.EmployeeCode;
    //this.CurrentSaveFollicularPickupsDetailV2Request.TreatmentCycle = this.FollicularPickupEndInfo.PickUpTreatmentCycle;
    //this.CurrentSaveFollicularPickupsDetailV2Request.FollicularGrowth = this.FollicularPickupEndInfo.FollicularGrowth;
    //this.CurrentSaveFollicularPickupsDetailV2Request.CycleActivity = this.FollicularPickupEndInfo.PickupCycleActivity;
    this.CurrentSaveFollicularPickupsDetailV2Request.ConditionalOperator = 3;
    this.actorservice.SaveFollicularPickupsDetailV2(this.CurrentSaveFollicularPickupsDetailV2Request)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            //this.activeModal.close();
            //this.clearData();
            //this.LoadScansData();
            this.stopRefreshing();

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            alert(this.ApiResData.ErrorData);


          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );


  }
  onSubmitTeam() {
    this.CurrentSaveFollicularPickupsDetailV2Request.Surgeon = this.FollicularPickupEndInfo.Surgeon;
    //this.CurrentSaveFollicularPickupsDetailV2Request.SurgeonName = this.FollicularPickupEndInfo.SurgeonName;
    this.CurrentSaveFollicularPickupsDetailV2Request.AsstSurgeon = this.FollicularPickupEndInfo.AsstSurgeon;
    //this.CurrentSaveFollicularPickupsDetailV2Request.AsstSurgeonName = this.FollicularPickupEndInfo.AsstSurgeonName;
    this.CurrentSaveFollicularPickupsDetailV2Request.Anesthesiologist = this.FollicularPickupEndInfo.Anesthesiologist;

    //this.CurrentSaveFollicularPickupsDetailV2Request.AnesthesiologistName = this.FollicularPickupEndInfo.AnesthesiologistName;
    this.CurrentSaveFollicularPickupsDetailV2Request.AnaesthesiaType = this.FollicularPickupEndInfo.AnaesthesiaType;
    this.CurrentSaveFollicularPickupsDetailV2Request.FollicularPickupCode = this.FollicularPickupEndInfo.IvfCycleFolliculePickupCode;
    this.CurrentSaveFollicularPickupsDetailV2Request.TreatmentCycleCode = this.FollicularPickupEndInfo.TreatmentCycle;
    this.CurrentSaveFollicularPickupsDetailV2Request.ActivityApprovedActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.CurrentSaveFollicularPickupsDetailV2Request.ActivityApprovedEmpCode = AppData.Instance().UserLoginDetails.EmployeeCode;
    this.CurrentSaveFollicularPickupsDetailV2Request.ConditionalOperator = 4;
    this.actorservice.SaveFollicularPickupsDetailV2(this.CurrentSaveFollicularPickupsDetailV2Request)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            //this.activeModal.close();
            //this.clearData();
            //this.LoadScansData();
            this.stopRefreshing();

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            alert(this.ApiResData.ErrorData);


          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );


  }
  onSubmitProcedureDetails() {
    this.CurrentSaveFollicularPickupsDetailV2Request.NeedleUsed = this.FollicularPickupEndInfo.NeedleUsed;
    this.CurrentSaveFollicularPickupsDetailV2Request.Route = this.FollicularPickupEndInfo.Route;
    this.CurrentSaveFollicularPickupsDetailV2Request.Complications = this.FollicularPickupEndInfo.Complications;
    this.CurrentSaveFollicularPickupsDetailV2Request.FollicularPickupCode = this.FollicularPickupEndInfo.IvfCycleFolliculePickupCode;
    this.CurrentSaveFollicularPickupsDetailV2Request.TreatmentCycleCode = this.FollicularPickupEndInfo.TreatmentCycle;
    this.CurrentSaveFollicularPickupsDetailV2Request.ActivityApprovedActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.CurrentSaveFollicularPickupsDetailV2Request.ActivityApprovedEmpCode = AppData.Instance().UserLoginDetails.EmployeeCode;
    this.CurrentSaveFollicularPickupsDetailV2Request.AnaesthesiaType = this.FollicularPickupEndInfo.AnaesthesiaType;
    this.CurrentSaveFollicularPickupsDetailV2Request.ConditionalOperator = 5;
    this.actorservice.SaveFollicularPickupsDetailV2(this.CurrentSaveFollicularPickupsDetailV2Request)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            //this.activeModal.close();
            //this.clearData();
            //this.LoadScansData();
            this.stopRefreshing();

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            alert(this.ApiResData.ErrorData);


          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  sum: number;
  TotalOocytes: number;
  onSubmitPickUpSizes() {

    this.CurrentSaveFollicularPickupsDetailV2Request.MinPickupSize = this.FollicularPickupEndInfo.MinPickupSize;
    this.CurrentSaveFollicularPickupsDetailV2Request.RFollicleCount = this.FollicularPickupEndInfo.RFollicleCount;
    this.CurrentSaveFollicularPickupsDetailV2Request.LFollicleCount = this.FollicularPickupEndInfo.LFollicleCount;
    this.CurrentSaveFollicularPickupsDetailV2Request.RFollicleAspirated = this.FollicularPickupEndInfo.RFollicleAspirated;
    this.CurrentSaveFollicularPickupsDetailV2Request.LFollicleAspirated = this.FollicularPickupEndInfo.LFollicleAspirated;
    this.CurrentSaveFollicularPickupsDetailV2Request.TotalRtOocytes = this.FollicularPickupEndInfo.TotalRtOocytes;
    this.CurrentSaveFollicularPickupsDetailV2Request.TotalLtOocytes = this.FollicularPickupEndInfo.TotalLtOocytes;
    this.TotalOocytes = this.FollicularPickupEndInfo.TotalRtOocytes + this.FollicularPickupEndInfo.TotalLtOocytes;
    this.CurrentSaveFollicularPickupsDetailV2Request.TotalOocytes = this.TotalOocytes;
    this.CurrentSaveFollicularPickupsDetailV2Request.FollicularPickupCode = this.FollicularPickupEndInfo.IvfCycleFolliculePickupCode;
    this.CurrentSaveFollicularPickupsDetailV2Request.TreatmentCycleCode = this.FollicularPickupEndInfo.TreatmentCycle;
    this.CurrentSaveFollicularPickupsDetailV2Request.ActivityApprovedActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.CurrentSaveFollicularPickupsDetailV2Request.ActivityApprovedEmpCode = AppData.Instance().UserLoginDetails.EmployeeCode;
    this.CurrentSaveFollicularPickupsDetailV2Request.ConditionalOperator = 6;
    this.actorservice.SaveFollicularPickupsDetailV2(this.CurrentSaveFollicularPickupsDetailV2Request)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            //this.activeModal.close();
            //this.clearData();
            //this.LoadScansData();
            this.stopRefreshing();

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            alert(this.ApiResData.ErrorData);


          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
  onAssignedToActorCode2(event: any) {

    if (event != null) {
      //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
      this.CurrentSaveFollicularPickupsDetailV2Request.MedicineCode = event;
      this.CurrentSaveFollicularPickupsDetailV2Request.MedicineName = event;
      // console.log('event--_>' + event);
      //   }
    }

  }
  onAssignedToActorCode3(event: any) {

    if (event != null) {
      //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
      this.CurrentSaveFollicularPickupsDetailV2Request.MedicineCode2 = event;
      this.CurrentSaveFollicularPickupsDetailV2Request.MedicineName2 = event;
      // console.log('event--_>' + event);
      //   }
    }

  }
  onAssignedToActorCodesurgeon(event: any) {

    if (event != null) {
      //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
      this.CurrentSaveFollicularPickupsDetailV2Request.Surgeon = event;
      this.CurrentSaveFollicularPickupsDetailV2Request.SurgeonName = event;
      // console.log('event--_>' + event);
      //   }
    }

  }
  onAssignedToActorCodeAsstSurgeon(event: any) {

    if (event != null) {
      //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
      this.CurrentSaveFollicularPickupsDetailV2Request.AsstSurgeon = event;
      //alert(this.CurrentSaveFollicularPickupsDetailV2Request.AsstSurgeon);
      this.CurrentSaveFollicularPickupsDetailV2Request.AsstSurgeonName = event;
      // console.log('event--_>' + event);
      //   }
    }

  }
  onAssignedToActorCodeAnaesthetist(event: any) {

    if (event != null) {
      //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
      this.CurrentSaveFollicularPickupsDetailV2Request.Anesthesiologist = event;
      this.CurrentSaveFollicularPickupsDetailV2Request.AnesthesiologistName = event;
      // console.log('event--_>' + event);
      //   }
    }

  }
  ChangeRFollicle(event: any) {
    if (event != null) {
      this.FollicularPickupEndInfo.TotalRtOocytes = event;
    }
  }
  ChangeLFollicle(event: any) {
    if (event != null) {
      this.FollicularPickupEndInfo.TotalLtOocytes = event;
    }
  }
  pdata: any[];// = this.data;
  listFilter: string;
  ngOnChanges(changes: any) {
    if (JSON.stringify(changes).indexOf("data") != -1)
      this.pdata = this.CurrentReadyForPickUpsBetweenDateController;

    this.criteriaChange(this.listFilter);
  }
  criteriaChange(value: any) {
    if (this.filter != null) {
      if (value != '[object Event]') {
        this.listFilter = value;
        //alert(this.listFilter);
        this.pdata = this.filter.transform(this.CurrentReadyForPickUpsBetweenDateController,
          this.listFilter);
      }
    }
  }
  ProviderName: string
  SelectSurgeon() {
    const modalRef = this.modalService.open(NgbSearchProviderModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
        })
      modalRef.componentInstance.DoctorType = 'All';
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.ProviderName = receivedEntry;
      //alert(this.ProviderName);
    })
  }
  CurrentIvfCycleTestByCodeController: IvfCycleTestByCodeController[];
  CurrentIvfCycleTestByCodeRequest: IvfCycleTestByCodeRequest;

  LoadTestData() {
    //alert("ScansData")
    this.CurrentIvfCycleTestByCodeRequest = new IvfCycleTestByCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentIvfCycleTestByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfCycleTestByCodeController();
  }

  GetIvfCycleTestByCodeController() {
    //this.StartRefreshing();

    //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.CurrentIvfCycleTestByCodeRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
    this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.SelectedpatientDetails.PickUpCode;
    //alert(this.FormattedCode);
    this.actorservice.GetIvfCycleTestByCodeController(this.CurrentIvfCycleTestByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentIvfCycleTestByCodeController = this.ApiResData.Result;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          // this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentIvfCycleMedicineByCodeController: IvfCycleMedicineByCodeController[];
  CurrentIvfCycleMedicineByCodeRequest: IvfCycleMedicineByCodeRequest;

  LoadMedicineData() {
    //alert("ScansData")
    this.CurrentIvfCycleMedicineByCodeRequest = new IvfCycleMedicineByCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentIvfCycleMedicineByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfCycleMedicineByCodeController();
  }

  GetIvfCycleMedicineByCodeController() {
    // this.StartRefreshing();

    //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.CurrentIvfCycleMedicineByCodeRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
    this.CurrentIvfCycleMedicineByCodeRequest.ActivityCode = this.SelectedpatientDetails.PickUpCode;
    //alert(this.FormattedCode);
    this.actorservice.GetIvfCycleMedicineByCodeController(this.CurrentIvfCycleMedicineByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentIvfCycleMedicineByCodeController = this.ApiResData.Result;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          // this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  AddTests() {
    const modalRef = this.modalService.open(NgbAddPickUpTestModal,
      {
        centered: true

      })
    modalRef.componentInstance.ActivityCode = this.SelectedpatientDetails.PickUpCode;
    modalRef.componentInstance.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    modalRef.componentInstance.ActorCode1 = this.ActorCodeDetails.EggActorCode;
    modalRef.componentInstance.TestCode = this.CurrentIvfCycleTestByCodeController[0].TestCode;
    modalRef.componentInstance.ClinicalOrderItem = this.CurrentIvfCycleTestByCodeController[0].ClinicalOrderItem;
    modalRef.result.then(x => { this.GetIvfCycleTestByCodeController() })
  }
  AddMedicine() {
    const modalRef = this.modalService.open(NgbAddPickUpMedicineModal,
      {
        centered: true

      })
    modalRef.componentInstance.ActivityCode = this.SelectedpatientDetails.PickUpCode;
    modalRef.componentInstance.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    modalRef.componentInstance.ActorCode1 = this.ActorCodeDetails.OwnerActorCode;
    modalRef.componentInstance.MedicineCode = this.CurrentIvfCycleMedicineByCodeController[0].MedicineCode;
    modalRef.componentInstance.ClinicalOrderItem = this.CurrentIvfCycleMedicineByCodeController[0].ClinicalOrderItem;
    modalRef.result.then(x => { this.GetIvfCycleMedicineByCodeController() })
  }

  //Selectedpatient() {
  //  this.ScanDetails = true;
  //}
  BackTodashboard() {
    //this.Showivf = true;
    //this.Showpickup = false;
    this.router.navigate(['healins/ivfworkbench']);
  }
  pickup() {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {

      this.IsPickupConfirmed();

      //this.DeleteActorIdentitiesMedicine(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }

  IsPickupConfirmed() {


    console.log('..................');
    this.StartRefreshing();
    this.CurrentUpdateIvfCycleByActivityRequest.TreatmentCycleCode = this.FollicularPickupEndInfo.TreatmentCycle;
    this.CurrentUpdateIvfCycleByActivityRequest.ActivityName = "ConfirmPickup";
    this.CurrentUpdateIvfCycleByActivityRequest.ActivityApprovedActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.CurrentUpdateIvfCycleByActivityRequest.ActivityApprovedEmpCode = AppData.Instance().UserLoginDetails.EmployeeCode;
    this.CurrentUpdateIvfCycleByActivityRequest.TotalFolicularCount = this.FollicularPickupEndInfo.TotalLtOocytes + this.FollicularPickupEndInfo.TotalRtOocytes;
    this.CurrentUpdateIvfCycleByActivityRequest.ActivityDate = new Date(this.parserFormatter.format(this.OvulationTriggerDate));
    this.CurrentUpdateIvfCycleByActivityRequest.ActivityTime = this.FollicularPickupEndInfo.OvumPickupTime;
    this.CurrentUpdateIvfCycleByActivityRequest.ConditionalOperator = 10;
    this.CurrentUpdateIvfCycleByActivityRequest.DOC = this.FollicularPickupEndInfo.DOC;
    this.CurrentUpdateIvfCycleByActivityRequest.Dosage = this.FollicularPickupEndInfo.Dosage;
    this.CurrentUpdateIvfCycleByActivityRequest.MedicineCode = this.FollicularPickupEndInfo.MedicineCode;
    this.CurrentUpdateIvfCycleByActivityRequest.MedicineName = this.FollicularPickupEndInfo.MedicineName;
    //this.CurrentActorDeleteDocRquest.DocType = "Clincial Record"
    //this.CurrentActorDeleteDocRquest.ActorCode = this.ActorCode;


    //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.actorservice.UpdateIvfCycleByActivityV2(this.CurrentUpdateIvfCycleByActivityRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.clearData2();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Removed Successfully.....!');
            //this.ShowList = true;
            //this.LoadMedicineData();

            this.stopRefreshing();

          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  BackToPatientdata() {
    this.displayPatientdata = true;
    this.displayscansdata = false;
  }
  printpickup() {
    //this.router.navigate(['print/pickupdetails', { PickupCodeData: this.SelectedpatientDetails.PickUpCode, Owner: this.SelectedpatientDetails.OwnerName, CycleNo: this.SelectedpatientDetails.CycleNo, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, PatientID: this.SelectedpatientDetails.OwnerFormattedCode, Infertility: this.SelectedpatientDetails.InfertilityType, Protocolst: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEd: this.SelectedpatientDetails.ProtocolEndDate, Protocol: this.SelectedpatientDetails.ProtocolName }]);
    this.printService.printDocument("pickupdetails",
      {
        PickupCodeData: this.SelectedpatientDetails.PickUpCode, Owner: this.SelectedpatientDetails.OwnerName, CycleNo: this.SelectedpatientDetails.CycleNo, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, PatientID: this.SelectedpatientDetails.OwnerFormattedCode, Infertility: this.SelectedpatientDetails.InfertilityType, Protocolst: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEd: this.SelectedpatientDetails.ProtocolEndDate, Protocol: this.SelectedpatientDetails.ProtocolName,
        OvulationTriggerTime: this.FollicularPickupEndInfo.OvulationTriggerTime, OvulationTriggerDate: this.FollicularPickupEndInfo.OvulationTriggerDate, MedicineName: this.FollicularPickupEndInfo.MedicineName, Dosage: this.FollicularPickupEndInfo.Dosage, SurgeonName: this.FollicularPickupEndInfo.SurgeonName, AsstSurgeonName: this.FollicularPickupEndInfo.AsstSurgeonName, AnaesthesiaType: this.FollicularPickupEndInfo.AnaesthesiaType, AnesthesiologistName: this.FollicularPickupEndInfo.AnesthesiologistName, NeedleUsed: this.FollicularPickupEndInfo.NeedleUsed,
        Route: this.FollicularPickupEndInfo.Route, Complications: this.FollicularPickupEndInfo.Complications, MinPickupSize: this.FollicularPickupEndInfo.MinPickupSize, PickupSizeUnits: this.FollicularPickupEndInfo.PickupSizeUnits, OvumPlannedPickupDate: this.FollicularPickupEndInfo.OvumPlannedPickupDate, OvumPickupdate: this.FollicularPickupEndInfo.OvumPickupdate, OvumPickupTime: this.FollicularPickupEndInfo.OvumPickupTime, RFollicleCount: this.FollicularPickupEndInfo.RFollicleCount, LFollicleCount: this.FollicularPickupEndInfo.LFollicleCount,
        RFollicleAspirated: this.FollicularPickupEndInfo.RFollicleAspirated, LFollicleAspirated: this.FollicularPickupEndInfo.LFollicleAspirated, TotalRtOocytes: this.FollicularPickupEndInfo.TotalRtOocytes, TotalLtOocytes: this.FollicularPickupEndInfo.TotalLtOocytes, TotalOocytes: this.FollicularPickupEndInfo.TotalOocytes
      }

    );
  }
}
